<template>
  <div id="editDsMailerContainer">
    <datasource-mailer v-model="datasourceMailer" @on-save="handleSave" />
  </div>
</template>

<script>
import DatasourceMailer from './DatasourceMailer'
import { useDatasourceMailerCrud } from './crudComposable'

export default {
  setup () {
    const { datasourceMailer, save, fetch } = useDatasourceMailerCrud()
    return {
      datasourceMailer,
      save,
      fetch
    }
  },
  components: {
    DatasourceMailer
  },
  methods: {
    async handleSave (datasourceMailer) {
      try {
        await this.save(datasourceMailer)
        this.$router.push({ name: 'datasource_mailers_path' })
      } catch (error) {
        this.$logger.error(error.message)
        this.$flash({
          showClose: true,
          message: `Error Saving Datasource Mailer. ${error.message}`,
          type: 'error',
          duration: 0
        })
      }
    }
  },
  mounted () {
    this.fetch(this.$route.params.id)
  }
}
</script>
